/**
 * Created by Mark on 24/04/2017.
 */

import React  from 'react';

import {Button , Nav , Navbar} from 'react-bootstrap';
import Panel from './panel.js';
import Translation from '../../store/internationalization-store.js';

export default class Profile extends React.Component {

    constructor(props){
        super();
        this.props = props;

        this.state ={
            panelIndex:props.panelIndex||0,
            sidePanel:props.sidePanel
        };

        this.handelTabSelect = this.handelTabSelect.bind(this);
    }

    handelTabSelect(panel){
        this.setState({panelIndex:panel})
    }

    componentWillReceiveProps(props){
        this.setState({sidePanel:props.sidePanel})
    } 

    goToAssign() {
        if (window.location.hash.indexOf("libraryFake") > -1) {
            window.location.hash="#/assignments/libraryAssignFake/"+this.props.id
        } else {
            window.location.hash="#/assignments/libraryAssign/"+this.props.id+"/"+this.props.curriculumID+"/"+this.props.data.homework.languageCode
        }
    }


    render(){

        const tabs = this.props.panels.map(function(tab , index){
            return <Nav.Item><Nav.Link key={"panel-"+index} eventKey={index} >{tab.name()}</Nav.Link> </Nav.Item>;
        });

        const panel     =  this.props.panels[this.state.panelIndex];
        if (panel == undefined) {
            return "";
        }
        const Component = React.createElement(Panel, {
            data:this.props.data,
            component:panel.component
        });

        var fd = <Button className="float-right" onClick={this.goToAssign.bind(this)}>{Translation.get(12610 , 'Create an Assignment')}</Button>
        if (window.location.hash.indexOf("library") > -1) {
            fd = <Button className="float-right" onClick={this.goToAssign.bind(this)}>{Translation.get(501 , 'Assign')}</Button>
        }


        return  <div body id="profile-main">

            <Navbar style={{padding:0}}>
                <Nav activeKey={this.state.panelIndex} onSelect={this.handelTabSelect}>
                    {tabs}
                </Nav>
                <Navbar.Collapse className="justify-content-end">
                {fd}
                </Navbar.Collapse>
            </Navbar>
            <hr/>
                        {Component}
               </div>;

    }

}